import qwest from 'qwest';

import EmailPreferences from '../models/emailPreferences.jsx';

let onSuccess = () => {
  return (xhr, response) => {
    if (response.success) {
      return response.data;
    }
    throw response;
  };
};

let onError = () => {
  throw {
    code: -1,
    data: null,
    message: 'Unexpected Error',
    success: false,
  };
};

export default {

  direct(emails, subject, body, comment, customerID, bodyFr) {
    return qwest.post('/Email/Direct', {
      emails,
      subject,
      body,
      bodyFr,
      comment,
      customerID,
    })
    .then(onSuccess(), onError);
  },

  analysis(emails, analysisID, data, comment, reportURL) {
    return qwest.post('/Email/Analysis', {
      emails,
      analysisID,
      data,
      comment,
      reportURL,
    })
    .then(onSuccess(), onError);
  },

  seasonUsage(emails, subject, body, reportURL) {
    return qwest.post('/Email/SeasonUsage', {
      emails: emails,
      subject: subject,
      body: body,
      reportURL: reportURL,
    })
    .then(onSuccess(), onError);
  },

  getPreferences(id, isDealer) {
    return qwest.post('/Email/GetPreferences', {
      id: id,
      isDealer: isDealer,
    })
    .then(onSuccess(), onError);
  },

  savePreferences(preferences) {
    let prefs = preferences.toApiFormat();

    return qwest.post('/Email/SavePreferences', prefs)
    .then((xhr, response) => {
      if (response.success) {
        let prefs = EmailPreferences.fromApiFormat(response.data);

        return prefs;
      }
      throw response;
    });
  },

  encyclopedia(emails, article, comment) {
    return qwest.post('/Email/Encyclopedia', {
      article: article,
      emails: emails,
      comment: comment,
    });
  },

  history(emails, report, comment, customerID, reportFr) {
    return qwest.post('/Email/ReportHistory', {
      emails,
      comment,
      report,
      reportFr,
      customerID,
    });
  },

  getEmail(name, locale) {
    return qwest.post('/Email/Body', {
      name,
      locale,
    })
      .then((xhr, res) => res);
  },
};
